import $ from 'jquery';

export default class TemplateCollection {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);

    this.titleContainer = $('.page-title', this.el);
    this.title = this.titleContainer.find('.label');
    this.tagsWrap = $('.tags-wrap', this.el);
    this.tags = this.tagsWrap.find('.tags');
    this.tagsWrap.removeClass('preload');

    $('#sort-by', this.el).on('change', this.sortDropDown.bind(this));

    this.tagFilters();
    this.setSortDropdown();
  }

  setSortDropdown() {
    const urlParam = new RegExp('[?&]sort_by=([^&#]*)').exec(window.location.href);
    if (urlParam && urlParam[1]) {
      $('#sort-by', this.el).val(urlParam[1]);
    }
  }

  sortDropDown(e) {
    Shopify.queryParams = {};
    if (location.search.length) {
      let aKeyValue;
      let i = 0;
      const aCouples = location.search.substr(1).split('&');
      while (i < aCouples.length) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
        i++;
      }
    }

    Shopify.queryParams.sort_by = $(e.currentTarget, this.el).val();

    location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  tagFilters() {
    const collFilters = $('.coll-filter', this.el);

    collFilters.on('change', (event) => {
      const newTags = [];
      const dataUrl = $(event.currentTarget).data('window-href');

      collFilters.each((index, el) => {
        const $el = $(el);

        if ($el.val()) {
          newTags.push($el.val());
        }
      });

      if (newTags.length) {
        const query = newTags.join('+');
        window.location.href = `${dataUrl}/${query}`;
      } else {
        window.location.href = dataUrl;
      }
    });
  }
}
